module.exports = __webpack_public_path__ + "static/img/picture20.89bf50d6.png";